<template>
  <!--APPKEY管理-->
  <div class="appkey-manage" v-loading="loading">
    <p class="title">APPKEY管理</p>
    <div class="key-item" v-for="(item, index) of keyList" :key="index">
      <p class="item">APPKEY：{{ item.appkey }}</p>
      <p class="item">
        APPSECRET：{{ showSecretFlags[index] ? item.appSecret : maskSecret(item.appSecret) }}
        <i
          :class="showSecretFlags[index] ? 'eyes-open' : 'eyes-close'"
          @click="toggleSecret(index)"
        />
      </p>
    </div>
  </div>
</template>

<script>
import { findAllMerchant } from "../../assets/js/http-serve/corp/http-methods";

export default {
  name: "appkey-manage",
  data() {
    return {
      loading: false,
      showSecretFlags: [], //每条APPSECRET是否显示明文，默认全脱敏
      keyList: []
    };
  },
  beforeMount() {
    this.getKeyList();
  },
  methods: {
    /** 获取当前账号下所有的APPKEY及APPSECRET */
    getKeyList() {
      this.loading = true;
      findAllMerchant()
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.keyList = res.data || [];
          this.showSecretFlags = this.keyList.map(() => false);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** APPSECRET脱敏展示，长度与真实值一致 */
    maskSecret (secret) {
      const len = (secret || "").length || 32;
      return "*".repeat(len);
    },
    /** 切换某条APPSECRET显示/脱敏 */
    toggleSecret (index) {
      this.$set(this.showSecretFlags, index, !this.showSecretFlags[index]);
    }
  }
};
</script>

<style lang="less" scoped>
.appkey-manage {
  padding: 24px;
  .title {
    margin-bottom: 24px;
    font-weight: bold;
    color: #333;
  }
  .key-item {
    margin-bottom: 16px;
  }
  .item {
    margin-bottom: 16px;
    color: #333;
    // 与登录密码框相同的睁眼/闭眼图标，不做颜色区分
    .eyes-open,
    .eyes-close {
      margin-left: 8px;
      width: 20px;
      height: 12px;
      display: inline-block;
      cursor: pointer;
    }
    .eyes-open {
      background: url("/static/images/eyes-open.png") no-repeat;
    }
    .eyes-close {
      background: url("/static/images/eyes-close.png") no-repeat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/ent-access/appkeyManage.vue